/**
 * Domain-owned Techline status enum. This is the canonical set of 8 official statuses that domain
 * and web code should use. The DTO enum in `@packages/clients` contains additional legacy and
 * NorthStar values that may arrive from the backend; those are normalized to these official values
 * at the DTO-to-entity boundary via `normalizeTechlineStatus`.
 */
export enum TechlineStatusCode {
    AUTO_CLOSED = 'AUTO CLOSED',
    CLOSE_RESOLVED = 'CLOSE RESOLVED',
    CLOSED = 'CLOSED',
    DRAFT = 'DRAFT',
    ESCALATED = 'ESCALATED',
    IN_REVIEW = 'IN REVIEW',
    PENDING_TECHLINE = 'PENDING TECHLINE',
    UPDATE_REQUESTED = 'UPDATE REQUESTED',
}

/**
 * Flags indicating which features are allowed for a given case.
 * These are determined by the backend based on the case type.
 * Example useage: For a CID/CVN case, allowFailCodes would be false, since fail codes are not relevant to that case type.
 */
export type AllowCaseFeatures = {
    /** Whether the case can have DTC codes added. */
    allowDtcCodes: boolean;

    /** Whether the case can have fail codes added. */
    allowFailCodes: boolean;

    /** Whether the case can have worksheets added. */
    allowAdditionalWorksheets: boolean;

    /** Whether the case should display customer concern details. */
    allowCustomerConcernDetails: boolean;

    /** Whether the case should display a tech description field. */
    allowTechDescription: boolean;

    /** Whether the case can be closed. */
    allowCloseCase: boolean;
};
